import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import invariant from 'invariant';
import querystring from 'query-string';

export default function deleteOrderItem(params) {
    const {
        baseUrl,
        brandId,
        country,
        language,
        partNumber,
        orderItemId,
        quantity,
        uberToken,
        clientId,
        clientSecret,
        langId,
        additionalHeaders = {},
        clearMessages = false,
    } = params;

    invariant(baseUrl, 'baseUrl is a required param of deleteOrderItem()');
    invariant(brandId, 'brandId is a required param of deleteOrderItem()');
    invariant(country, 'country is a required param of deleteOrderItem()');
    invariant(language, 'language is a required param of deleteOrderItem()');
    invariant(partNumber, 'partNumber is a required param of deleteOrderItem()');
    invariant(orderItemId, 'orderItemId is a required param of deleteOrderItem()');
    invariant(typeof quantity === 'number', 'quantity is a required param of deleteOrderItem()');
    invariant(uberToken, 'uberToken is a required param of deleteOrderItem()');
    invariant(clientId, 'clientId is a required param of deleteOrderItem()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const query = querystring.stringify({ langId });
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/cart${query ? `?${query}&clearMessages=${clearMessages}` : ''}`;

    const body = JSON.stringify({
        orderItem: [{ partNumber, quantity, orderItemId }],
    });

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'DELETE', body }), uberToken, clientId, clientSecret),
        'deleteOrderItem',
    );
}
